export enum EActive {
  UNKNOWN = 0,
  INACTIVE,
  ACTIVE,
}
